import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import LineCallback from './pages/LineCallback';
import { StaffDashboard } from './pages/StaffDashboard';
import { ClockInDialog } from './pages/ClockInDialog';
import { Login } from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import { AuthProvider } from './contexts/AuthContext';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';

export function App() {
  return (
    <MantineProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* スタッフ向けルート */}
            <Route path="/login" element={<Login userType="staff" />} />
            <Route path="/dashboard" element={<StaffDashboard />} />
            <Route path="/clock-in" element={<ClockInDialog />} />
            
            {/* 管理者向けルート - 完全に分離 */}
            <Route path="/enlightadmin/login" element={<Login userType="admin" />} />
            <Route path="/enlightadmin/dashboard" element={<AdminDashboard />} />
            
            {/* LINE認証関連 */}
            <Route path="/auth/line/callback" element={<LineCallback />} />
            
            {/* ルートパスはスタッフのログインページにリダイレクト */}
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </MantineProvider>
  );
}
